// extracted by mini-css-extract-plugin
export var privacyPolicy = "index-module--privacyPolicy--9-JzW";